export default function Sync({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.2002 11.7998V12C19.2002 15.8523 16.1745 18.9976 12.3701 19.1904L12 19.2002C10.1392 19.2001 8.44407 18.4903 7.16699 17.332L6.11328 18.3887L5.52051 14.7246L5.47656 14.4502L5.75 14.4951L9.41406 15.0879L8.46582 16.0332C9.41041 16.8618 10.6456 17.3642 12 17.3643C14.9624 17.364 17.3633 14.9625 17.3633 12V11.7998H19.2002Z"
        fill="currentColor"
      />
      <path
        d="M12 4.7998C13.7006 4.7998 15.2626 5.39313 16.4941 6.37891L17.2988 5.57617L17.5752 5.2998L18.168 8.96387L18.2119 9.2373L17.9385 9.19336L14.2744 8.60059L14.5508 8.32422L15.1875 7.68555C14.2961 7.02546 13.1943 6.63574 12 6.63574C9.03741 6.63574 6.63574 9.03741 6.63574 12V12.2002H4.7998V12C4.7998 8.02345 8.02345 4.7998 12 4.7998Z"
        fill="currentColor"
      />
    </svg>
  )
}
